import React, { MouseEvent } from 'react';

interface IFilteredBySearchBreadcrumb {
  defaultText: string;
}

export default function BillingSalesOrderIdBreadcrumb({
  defaultText,
}: IFilteredBySearchBreadcrumb) {
  const salesOrderId = new URL(window.location.href).searchParams.get('salesOrderId');
  
  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    window.location.reload();
  };

  if (!salesOrderId) {
    return <>{defaultText}</>;
  }

  return (
    <a onClick={onClick} href={window.location.href}>
      Sales Order id: {salesOrderId}
    </a>
  );
}
